import React from 'react'
import './BlueprintSelectorModal.css'

type Props = {
  blueprints: IBlueprint[]
  hiddenBlueprintIds: Set<string>
  onToggleBlueprint: (blueprintId: string, shouldShow: boolean) => void
}

const BlueprintSelectorModal = ({
  blueprints,
  hiddenBlueprintIds,
  onToggleBlueprint,
}: Props) => {
  if (blueprints.length === 0) {
    return (
      <div className="blueprint-selector-modal modal-form">
        図面がありません。
      </div>
    )
  }

  return (
    <div className="blueprint-selector-modal modal-form">
      <div className="blueprint-selector-list">
        {blueprints.map((blueprint) => {
          const blueprintId = String(blueprint.id)
          const isVisible = !hiddenBlueprintIds.has(blueprintId)
          return (
            <label className="blueprint-selector-item" key={blueprintId}>
              <input
                type="checkbox"
                defaultChecked={isVisible}
                onChange={(event) => onToggleBlueprint(blueprintId, event.target.checked)}
              />
              <span className="blueprint-selector-label">
                図面 #
                {blueprintId}
              </span>
              <img
                className="blueprint-selector-thumb"
                src={blueprint.image.url}
                alt={`blueprint-${blueprintId}`}
              />
            </label>
          )
        })}
      </div>
    </div>
  )
}

export default BlueprintSelectorModal
